import {Attendee} from 'Event/attendee'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'

export type MailchimpTag = {
  name: string
}

export function useAddTag() {
  const {client} = useEvent()

  const url = api('/tags/mailchimp')
  return (tag: MailchimpTag) => {
    try {
      client.post(url, {name: tag})
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/mailchimp/test_tag`)
  return async (tag: MailchimpTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      tag,
      attendee_id: attendee.id,
    })
  }
}
